import React, { useEffect } from 'react';
import { KeyCode } from '../util/Constants';
import SessionUtil from '../util/session/SessionUtil';

const GlobalShortcuts = (WrappedComponent: React.Component) => {
  return function GlobalShortcuts(props) {
    useEffect(() => {
      addEventListener();
      return () => {
        removeEventListener();
      };
    }, []);

    const addEventListener = () => {
      document.addEventListener('keydown', onKeyDown);
    };

    const removeEventListener = () => {
      document.removeEventListener('keydown', onKeyDown);
    };

    const onKeyDown = (e: KeyboardEvent) => {
      const { ctrlKey, shiftKey, metaKey, altKey, keyCode } = e;
      if (ctrlKey && shiftKey && keyCode === KeyCode.X) doLogout(e);
    };

    const doLogout = (e: KeyboardEvent) => {
      e.preventDefault();
      SessionUtil.logout();
    };

    return <WrappedComponent {...props}></WrappedComponent>;
  };
};

export default GlobalShortcuts;
